require('./bootstrap')

import {createApp, h} from 'vue'
import {createInertiaApp, Head as InertiaHead, Link as InertiaLink} from '@inertiajs/vue3'

// Plugins
import {vfmPlugin} from 'vue-final-modal'
import VCalendar from 'v-calendar';
import Store from '@/store';

// Global components
import LoadingView from '@/components/Shared/LoadingView'
import Sprites from '@/components/Shared/Sprites';

import i18n from './utils/locales';
import permissions from './utils/permissions';
import Messages from './ll_messages';
import moment from 'moment';

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({el, App, props, plugin}) {
    const VueApp = createApp({render: () => h(App, props)})
    const route = window.route

    VueApp.config.globalProperties.moment = moment
    VueApp.config.globalProperties.$route = route

    VueApp
      .use(plugin)
      .use(vfmPlugin)
      .use(VCalendar)
      .use(Store)
      .use(permissions)
      .use(i18n, {
        messages: Messages,
        locale: window.defaultLocale,
        fallback: window.fallbackLocale
      })
      .mixin({methods: {route}})
      .component('Sprites', Sprites)
      .component('InertiaHead', InertiaHead)
      .component('InertiaLink', InertiaLink)
      .component('LoadingView', LoadingView)
      .mount(el)
  },
  progress: {
    delay: 250,
    color: '#00a8ff',
    includeCSS: true,
    showSpinner: false,
  },
});
